import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {CvDto} from 'src/app/services/api-client/models/cv-dto';
import {CvRestControllerService} from 'src/app/services/api-client/services';
import { CvTypeEnum } from 'src/app/shared/enums/cvType.model';

@Injectable({
    providedIn: 'root'
})
export class CvsByUserIdAndCvTypeResolver implements Resolve<CvDto> {

  constructor(public cvService: CvRestControllerService) {}

  resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<any> {
    let userId = parseInt(route.paramMap.get('userId'));
    return this.cvService.getCvsByUserIdAndCvType({userId: userId, cvType: CvTypeEnum.CONSULTANT_CV});
  }
}